/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefProjectData } from '../../models/api-def-project-data';
import { ApiDefSpecData } from '../../models/api-def-spec-data';

export interface OrganizationsDeleteSpecVersion$Params {

/**
 * The ID of the organization to delete the spec version from
 */
  organizationId: string;

/**
 * The ID of the project to delete the spec version from
 */
  projectId: string;

/**
 * The ID of the upload intent to delete the spec version for
 */
  uploadIntentId: string;
}

export function organizationsDeleteSpecVersion(http: HttpClient, rootUrl: string, params: OrganizationsDeleteSpecVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;
'spec'?: ApiDefSpecData;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsDeleteSpecVersion.PATH, 'delete');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('projectId', params.projectId, {});
    rb.path('uploadIntentId', params.uploadIntentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'project'?: ApiDefProjectData;
      'spec'?: ApiDefSpecData;
      }>;
    })
  );
}

organizationsDeleteSpecVersion.PATH = '/organizations/{organizationId}/projects/{projectId}/specs/{uploadIntentId}';
